var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardpeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21,
    r: 21,
    fill: "#FBEFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 29C26 27.3431 23.7614 26 21 26C18.2386 26 16 27.3431 16 29M30 26.0004C30 24.7702 28.7659 23.7129 27 23.25M12 26.0004C12 24.7702 13.2341 23.7129 15 23.25M27 19.2361C27.6137 18.6868 28 17.8885 28 17C28 15.3431 26.6569 14 25 14C24.2316 14 23.5308 14.2889 23 14.7639M15 19.2361C14.3863 18.6868 14 17.8885 14 17C14 15.3431 15.3431 14 17 14C17.7684 14 18.4692 14.2889 19 14.7639M21 23C19.3431 23 18 21.6569 18 20C18 18.3431 19.3431 17 21 17C22.6569 17 24 18.3431 24 20C24 21.6569 22.6569 23 21 23Z",
    stroke: "#874FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardpeople);
export default __webpack_public_path__ + "static/media/dashboardpeople.c2b27e307e7ebd9362af157b175c9021.svg";
export { ForwardRef as ReactComponent };